import { ArrowRight, ChevronLeft } from 'lucide-react';
import { DialogContent, DialogDescription, DialogTitle } from '../ui/dialog';

const arrowClass = 'absolute top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-secondary border border-border hover:bg-primary text-white flex items-center justify-center transition-colors z-10';

export const GalleryLightbox = ({ kind, title, gallery }) => (
  <DialogContent
    data-testid={`${kind}-lightbox`}
    className="z-[101] flex h-[100dvh] w-screen max-w-none items-center justify-center border-0 rounded-none sm:rounded-none bg-background/95 p-4"
    overlayClassName="z-[100] bg-background/95 backdrop-blur-sm"
    closeButtonProps={{ 'data-testid': `${kind}-lightbox-close-button`, 'aria-label': 'Kapat' }}
    closeLabel="Kapat"
    onClick={(event) => { if (event.target === event.currentTarget) gallery.setOpen(false); }}
  >
    <DialogTitle className="sr-only">{title}</DialogTitle>
    <DialogDescription className="sr-only">{gallery.activeIndex + 1} / {gallery.count}</DialogDescription>
    {gallery.count > 1 && (
      <>
        <button data-testid={`${kind}-lightbox-previous-button`} type="button" aria-label="Onceki" onClick={gallery.previous} className={`${arrowClass} left-5`}>
          <ChevronLeft size={22} />
        </button>
        <button data-testid={`${kind}-lightbox-next-button`} type="button" aria-label="Sonraki" onClick={gallery.next} className={`${arrowClass} right-5`}>
          <ArrowRight size={20} />
        </button>
      </>
    )}
    <div className="relative max-w-[90vw] max-h-[90vh] flex items-center justify-center">
      <img data-testid={`${kind}-lightbox-image`} src={gallery.image} alt={title} className="max-w-full max-h-[88vh] object-contain rounded-lg shadow-2xl" />
      <div data-testid={`${kind}-lightbox-caption`} aria-live="polite" className="absolute bottom-4 left-1/2 -translate-x-1/2 w-max max-w-full px-4 py-2 rounded-xl bg-background/90 backdrop-blur-md border border-border text-[12px] text-white/90 text-center break-words">
        {gallery.activeIndex + 1} / {gallery.count} &nbsp;·&nbsp; {title}
      </div>
    </div>
  </DialogContent>
);